<template>
  <div class="already-have-account">
    <span class="kds-typography-paragraph-large">
      {{ $t('generic_already_have_account') }}
    </span>
    <a
      :href="`/${corporate.key}/login`"
      class="already-have-account--link kds-color-text-interactive-accent kds-typography-title-medium"
      @click="redirectToLogin"
    >
      {{ $t('generic_click_to_login') }}</a
    >
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import useCorporateStore from '@shared/stores/useCorporateStore.js'

import ROUTE from '@us/app/router/appModule/names'

const corporateStore = useCorporateStore()
const router = useRouter()

const corporate = computed(() => corporateStore.corporate)

const redirectToLogin = (event) => {
  if (event) {
    event.preventDefault()
  }
  router.push({
    name: ROUTE.LOGIN,
    params: {
      corporate_key: corporate.value.key,
    },
  })
}
</script>

<style lang="scss">
.already-have-account {
  margin: auto;
  padding: $kds-space-1x 0;
  display: flex;
  gap: $kds-space-1x;
  align-items: baseline;

  @include media-up(lg) {
    padding-bottom: 0;
  }

  &--link {
    text-decoration: none;
  }
}
</style>
